import { UspFlow } from "../models/rs-data/textBlock";

export const isUspVisibleInFlow = (flow: UspFlow | undefined, isNexus: boolean): boolean => {
    if (!flow || flow === "All") return true;
    return flow === (isNexus ? "Nexus" : "Webshop");
};
